import React from 'react';
import { Link } from 'react-router-dom';

import notFoundImage from '../../assets/images/404.svg';

import style from './style.module.scss';

const NotFound = () => (
  <div className={style.pageContainer}>
    <div className={style.content}>
      <img src={notFoundImage} alt="Not Found" />

      <p>
        Oops! The camera&apos;s gone on vacation and took the page with it.
        Probably sipping pixels on a beach somewhere.
      </p>

      <Link to="/" className="logo-container">
        <button type="button">
          Return to Home Page
        </button>
      </Link>
    </div>
  </div>
);

export default NotFound;
